var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { class: 'scene-node node node-' + _vm.nodeId }, [_c('div', { staticClass: "scene-node-header", attrs: { "title": _vm.config.name } }, [_vm._v("\n    " + _vm._s(_vm.config.name) + "\n  ")]), _vm._v(" "), _vm.thumbnail ? _c('img', { attrs: { "src": _vm.thumbnail, "alt": "" } }) : _vm._e(), _vm._v(" "), _vm.currentSceneId === _vm.nodeId ? _c('el-button', { staticClass: "scene-node-edit-button", on: { "click": function click($event) {
        $event.stopPropagation();return _vm.toggle(_vm.isEditScene);
      } } }, [_vm._v("\n    " + _vm._s(_vm.isEditScene ? "退出编辑" : "编辑场景") + "\n  ")]) : _vm._e()], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };